export const formatNumberWithCommas = (value: string): string => {
  const numericValue = value.replace(/\D/g, "");
  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const removeCommas = (value: string): string => {
  return value.replace(/,/g, "");
};

export const formatNumber = (value: string | number): string => {
  const stringValue = typeof value === "number" ? value.toString() : value;
  return formatNumberWithCommas(stringValue);
};

export const parseFormattedNumber = (value: string): number => {
  const cleanValue = removeCommas(value);
  const parsed = parseInt(cleanValue, 10);
  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Format a byte count as a short human-readable size (e.g. "1.2 MB").
 */
export const formatFileSize = (bytes: number): string => {
  if (!bytes || bytes <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1
  );
  const value = bytes / Math.pow(1024, exponent);
  return `${exponent === 0 ? value : value.toFixed(1)} ${units[exponent]}`;
};
